import { render, staticRenderFns } from "./CoursewareTreeItem.vue?vue&type=template&id=63a5ce8b&"
import script from "./CoursewareTreeItem.vue?vue&type=script&lang=js&"
export * from "./CoursewareTreeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports